import { useState } from 'react';
import Sidebar from './common/SideBar';
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react';
import ACGLogoColoured from '../assets/acg-logo-coloured.png';
import { ChevronDown, PanelRight, SquarePlus } from 'lucide-react';
import { Link, useParams } from 'react-router';
import { useModuleContext } from '../context/ModuleContext';
import UserAvatar from './common/UserAvatar';

export default function Layout({ children }) {
  const { id } = useParams();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { selectedModule, setSelectedModule, getAllModuleConfigs, isLoadingApplications } = useModuleContext();
  
  const moduleConfigs = getAllModuleConfigs();

  const toggleSidebar = () => {
    setIsSidebarOpen((prevState) => !prevState);
  };

  return (
    <div className="flex flex-col lg:flex-row h-screen w-full">
      {/* Sidebar */}
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />

      {/* Main content */}
      <main
        className={`transition-all duration-300 flex-1 flex flex-col h-full w-full overflow-auto bg-[#090F16] text-white ${
          isSidebarOpen ? 'lg:ml-0' : ''
        }`}
      >
        <div className="w-full bg-black/20 p-4 border-b border-white/20">
          <div className="flex gap-2 items-center">
            {!isSidebarOpen && (
              <>
                <button className="cursor-pointer" onClick={toggleSidebar} title="Toggle Sidebar">
                  <PanelRight size={20} />
                </button>
                <Link to="/chat" className="cursor-pointer" title="New Chat">
                  <SquarePlus size={20} />
                </Link>
              </>
            )}
            {id ? (
              <Link to="/chat" className="flex gap-1 items-center" title="Home">
                <img src={ACGLogoColoured} className="w-fit h-5" />
                {isLoadingApplications ? 'Loading...' : (moduleConfigs[selectedModule]?.name || 'Unknown Module')}
              </Link>
            ) : (
              <Listbox value={selectedModule} onChange={setSelectedModule} disabled={isLoadingApplications}>
                <ListboxButton className={'text-sm flex gap-1 items-center cursor-pointer disabled:opacity-50'}>
                  <img src={ACGLogoColoured} className="w-fit h-5" /> 
                  {isLoadingApplications ? 'Loading modules...' : (moduleConfigs[selectedModule]?.name || 'Select Module')}
                  <ChevronDown size={18} />
                </ListboxButton>
                {!isLoadingApplications && (
                <ListboxOptions
                  className={
                    'bg-white/40 outline-none p-1.5 mt-2 rounded backdrop-blur-2xl space-y-1'
                  }
                  anchor="bottom"
                  transition
                >
                    {Object.values(moduleConfigs).length > 0 ? (
                      Object.values(moduleConfigs).map((config) => (
                    <ListboxOption className={'flex rounded'} key={config.key} value={config.key}>
                      {({ active, selected }) => (
                        <span
                          className={`w-full rounded px-2 py-1 hover:cursor-pointer ${active ? 'bg-black/60 text-white' : ''} ${selected ? 'font-medium' : ''}`}
                        >
                          {config.name}
                        </span>
                      )}
                    </ListboxOption>
                      ))
                    ) : (
                      <div className="px-2 py-1 text-gray-400">No active modules available</div>
                    )}
                </ListboxOptions>
                )}
              </Listbox>
            )}
            <div className="ml-auto">
              <UserAvatar />
            </div>
          </div>
        </div>
        {children}
      </main>
    </div>
  );
}
